import {UmpireQuizRanking} from '../umpire-quiz-ranking';
import {UmpireUser} from '../umpire-user';

export interface UmpireQuizUserAttempt {
  id: string;

  type: 'quiz_user_attempt';

  quiz_ranking: UmpireQuizRanking;

  user: UmpireUser;

  avg_answer_time: number;

  finished_at: string;

  is_banned: boolean;

  points: number;

  total_answers_time: number;
  correct_answers_time: number;
  max_points: number;
}
